import { useState, useEffect } from 'react';
import { configService, StringsConfig, FolderInfo } from '../services/configService';

export const useStrings = () => {
  const [strings, setStrings] = useState<StringsConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStrings = async () => {
      try {
        setLoading(true);
        const config = await configService.getStrings();
        setStrings(config);
        setError(null);
      } catch (err) {
        console.error('Failed to load strings config:', err);
        setError('Failed to load configuration');
      } finally {
        setLoading(false);
      }
    };

    loadStrings();
  }, []);

  return { strings, loading, error };
};

export const useFolderInfo = (folderId: string) => {
  const [folderInfo, setFolderInfo] = useState<FolderInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFolderInfo = async () => {
      try {
        setLoading(true);
        const info = await configService.getFolderInfo(folderId);
        setFolderInfo(info);
        setError(null);
      } catch (err) {
        console.error('Failed to load folder info:', err);
        setError('Failed to load folder configuration');
      } finally {
        setLoading(false);
      }
    };

    if (folderId) {
      loadFolderInfo();
    }
  }, [folderId]);

  return { folderInfo, loading, error };
};

export const useDefaultFolderId = () => {
  const [defaultFolderId, setDefaultFolderId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadDefaultFolderId = async () => {
      try {
        setLoading(true);
        const id = await configService.getDefaultFolderId();
        setDefaultFolderId(id);
        setError(null);
      } catch (err) {
        console.error('Failed to load default folder ID:', err);
        setError('Failed to load configuration');
      } finally {
        setLoading(false);
      }
    };

    loadDefaultFolderId();
  }, []);

  return { defaultFolderId, loading, error };
};